import { CopyIcon } from '@entur/icons';
import { useIntl } from 'react-intl';
import { useToast } from '@entur/alert';
import styles from './styles.module.scss';

interface CopyToClipboardProps {
  text: string;
  tabIndex?: number;
}

const CopyToClipboard = ({ text, tabIndex = 0 }: CopyToClipboardProps) => {
  const intl = useIntl();
  const { addToast } = useToast();

  const copy = () => {
    try {
      navigator.clipboard.writeText(text);
      addToast(intl.formatMessage({ id: 'toastAlerts.copied' }));
    } catch {
      addToast(intl.formatMessage({ id: 'toastAlerts.errorCopy' }));
    }
  };

  return (
    <CopyIcon
      tabIndex={tabIndex || 0}
      className={styles.pointer}
      onClick={copy}
      onKeyDown={(e: React.KeyboardEvent<SVGElement>) => {
        if (e.key === 'Enter') {
          copy();
        }
      }}
    />
  );
};

export default CopyToClipboard;
